// Derives a display-friendly ECG access status from a user record.
// Backend model (see User::canAccessEcg): access is granted if the permanent
// flag is set, OR now is inside the [ecg_enabled_from, ecg_enabled_until)
// window, OR ecg_trial_end_date is in the future.
const toDate = (value) => (value ? new Date(value) : null);
const fmt = (d) => d.toLocaleDateString();

export const getEcgStatus = (record) => {
  const now = new Date();
  const from = toDate(record.ecg_enabled_from);
  const until = toDate(record.ecg_enabled_until);
  const trialEnd = toDate(record.ecg_trial_end_date);

  const windowScheduled = from && from > now;
  const trialActive = trialEnd && trialEnd > now;

  if (record.ecg_enabled) {
    // An `until` date in the future bounds the access window
    // (e.g. subscription users: it tracks the next invoice date).
    if (until && until > now) {
      const dates = [from ? `Since ${fmt(from)}` : null].filter(Boolean);
      return { color: '#2e7d32', label: `ECG enabled until ${fmt(until)}`, dates };
    }
    if (!record.ecg_enabled_full && trialActive) {
      return { color: '#ed6c02', label: `ECG trial until ${fmt(trialEnd)}`, dates: [] };
    }
    const dates = [
      from ? `Since ${fmt(from)}` : null,
      until ? `Until ${fmt(until)}` : null,
    ].filter(Boolean);
    return { color: '#2e7d32', label: 'ECG enabled without expiration', dates };
  }

  if (windowScheduled) {
    return {
      color: '#1976d2',
      label: `ECG scheduled from ${fmt(from)}${until ? ` until ${fmt(until)}` : ''}`,
      dates: [],
    };
  }

  // No access: surface the dates of whatever already expired.
  const dates = [];
  if (trialEnd) dates.push(`Trial ended ${fmt(trialEnd)}`);
  if (until || from) {
    dates.push(`Access window${from ? ` ${fmt(from)}` : ''} → ${until ? fmt(until) : '…'} ended`);
  }
  return { color: '#d32f2f', label: 'ECG disabled', dates };
};
